import { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material";

import { Home, List, Logout, Map, Print, Report, Handshake, SettingsAccessibility,ViewAgenda } from "@mui/icons-material";
import "../no-print.css";
import RootLayout from "../RootLayout";

const theme = createTheme({
	components: {
		MuiIcon: {
			styleOverrides: {
				root: {
					// Match 24px = 3 * 2 + 1.125 * 16
					color: "white",
					boxSizing: "content-box",
					padding: 3,
					fontSize: "1.125rem",
				},
			},
		},
	},
});

const getThemedIcon = ({ icon }) => {
	return <ThemeProvider theme={theme}>{icon}</ThemeProvider>;
};

const parkStaffMenuItems = [
	{ key: "home", to: "/", title: "Home", iconClass: getThemedIcon({ icon: <Home /> }) },
	
	// Approve Group (kept intact)
	{
		key: "GROUP",
		iconClass: <Handshake />,
		title: "Approve",
		detail: [
			{
				key: "handover",
				to: "/approveHandover",
				title: "Handover",
				iconClass: <Handshake />,
			},
			{
				key: "InverstoActivity",
				to: "/approveinvestoractivity",
				title: "Inverstor Activity",
				iconClass: <Handshake />,
			},
		],
	},
	
	// Map Group (from code 2)
	{
		key: "GROUP",
		iconClass: <Handshake />,
		title: "Map",
		detail: [
			{ key: "viewMap", to: "/viewMap", title: "View Map", iconClass: <Map /> },
			{ key: "viewMapByCategory", to: "/viewMapByCategory", title: "View Map by Category", iconClass: <Map /> },
			{ key: "printMap", to: "/printMap", title: "Print Map", iconClass: <Print /> },
		],
	},

	// List Group (from code 2)
	{
		key: "GROUP",
		iconClass: <Handshake />,
		title: "List",
		detail: [
			{ key: "listParcel", to: "/listParcel", title: "Parcel", iconClass: <List /> },
			{ key: "investorList", to: "/investorList", title: "Investor", iconClass: <List /> },
			{ key: "agreementList", to: "/agreementList", title: "Agreement", iconClass: <List /> },
		],
	},
	
	{ key: "parkReport", to: "/PASummaryReport", title: "Reports", iconClass: <Report /> },
	{ key: "myPreference", to: "/myPreference", title: "Preferences", iconClass: <SettingsAccessibility /> },
	{ key: "logout", to: "/logout", title: "Logout", iconClass: <Logout /> },
];

export default function ParkAdminLayout() {
	const [open, setOpen] = useState(true);
	const [showProfile, setShowProfile] = useState(true);
	
	return (
		<RootLayout
			department="Park Admin"
			open={open}
			setOpen={setOpen}
			showProfile={showProfile}
			setShowProfile={setShowProfile}
			menuList={parkStaffMenuItems}
		/>
	);
}